import {ImplicitFlowService} from "./ImplicitFlowService";
import {env} from "core/env";

export class OwnerSummaryService extends ImplicitFlowService {
    private static baseUrl = env.REACT_APP_OWNER_SUMMARY_SERVICE_URL;
    private static service: OwnerSummaryService;

    constructor() {
        super(OwnerSummaryService.baseUrl);
    }

    /**
     * Get Singleton Instance
     */
    public static getInstance(): OwnerSummaryService {
        if (!OwnerSummaryService.service) {
            OwnerSummaryService.service = new OwnerSummaryService();
        }
        return OwnerSummaryService.service;
    }

    /**
     * TODO: Get Owner Summary Configuration
     * @returns Promise<any>
     */
    public async loadConfig(): Promise<any> {
        try {
            return Promise.resolve({});
        } catch (e) {
            if (!(e instanceof Error)) throw e;
            this.logger.error("loadConfig", e);
            throw e;
        }
    }
}
